export const PROJECT_SEARCH_UNFOCUSED_ACTIVE_EVENT =
  'bugherd:project-search-unfocused-active-change';

let unfocusedActive = false;

export const shouldHideFeedbackStatus = (
  searchActive: boolean,
  inputFocused: boolean
) => searchActive && !inputFocused;

export const getProjectSearchUnfocusedActive = () => unfocusedActive;

export const setProjectSearchUnfocusedActive = (
  nextUnfocusedActive: boolean
) => {
  if (unfocusedActive === nextUnfocusedActive) return;

  unfocusedActive = nextUnfocusedActive;
  window.dispatchEvent(
    new CustomEvent(PROJECT_SEARCH_UNFOCUSED_ACTIVE_EVENT, {
      detail: nextUnfocusedActive
    })
  );
};

export const subscribeToProjectSearchUnfocusedActive = (
  onChange: (nextUnfocusedActive: boolean) => void
) => {
  const handleChange = (event: Event) => {
    onChange((event as CustomEvent<boolean>).detail);
  };

  window.addEventListener(PROJECT_SEARCH_UNFOCUSED_ACTIVE_EVENT, handleChange);
  return () =>
    window.removeEventListener(
      PROJECT_SEARCH_UNFOCUSED_ACTIVE_EVENT,
      handleChange
    );
};
